import React from 'react';
import styles from './CardholderCell.module.css';

// Whose card a row was charged on: the holder's name, with "Ending NNNN" under
// it when the statement printed a number. Account-level rows (payments,
// interest, fees) and non-card accounts are muted so they don't read as a
// person (.claude/references/cardholder-reporting.md).
export default function CardholderCell({ isCard, name, ending }) {
  return (
    <span className={styles.cell}>
      <span className={isCard ? styles.holder : `${styles.holder} ${styles.muted}`} title={name}>
        {name}
      </span>
      {ending && <span className={styles.ending}>Ending {ending}</span>}
    </span>
  );
}
